import { render, staticRenderFns } from "./export-collaborators.vue?vue&type=template&id=2f720f62"
import script from "./export-collaborators.vue?vue&type=script&lang=js"
export * from "./export-collaborators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports